import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import { getAssetAttachments } from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsAssetAttachmentsLoading: (isLoading: boolean) => void;
	setAssetAttachmentsError: (err: string) => void;
};

export const useSearchAssetAttachments = ({
	setIsAssetAttachmentsLoading,
	setAssetAttachmentsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetAttachments },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setListAssetAttachments([]);
		setIsAssetAttachmentsLoading(true);
		const res = await getAssetAttachments(assetSearchId, includeDescendants);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAssetAttachments(rowsSource);
			setIsAssetAttachmentsLoading(false);
		} else {
			setAssetAttachmentsError(res.message);
			setIsAssetAttachmentsLoading(false);
		}
	};
};
